import React from 'react';
import Facets from './Facets';
import { Button } from 'reactstrap';
import { AttributesParamShape } from '../../Infrastructure/propShapes.js';
import { translateResourceString } from '../../../util/translationUtility';

class MobileFacets extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        require('./MobileFacets.css');
    }

    render() {
        const {
            onClearAttributes,
            showMobileFacets,
            onShowMobileFacetsChange,
        } = this.props;

        return (
            <div>
                { showMobileFacets &&
                    <div className="mobile-facets-container container d-lg-none">
                        {/*<div className="row bg-white">*/}
                        {/*    <div className="col-12">*/}
                        {/*        Filter Products <a onClick={() => onShowMobileFacetsChange(false)} className="float-right"><i className="fa fa-times"></i></a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="row">*/}
                        {/*    <div className="col-12">*/}
                        {/*        <div className="filter-products-row">*/}
                        {/*            <span className="filter-products">*/}
                        {/*                Filter Products*/}
                        {/*            </span>*/}
                        {/*            <a*/}
                        {/*                onClick={onClearAttributes}*/}
                        {/*                className="pull-right clear-all-filters"*/}
                        {/*            >*/}
                        {/*                Clear all filters*/}
                        {/*            </a>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        
                        <div className="row">
                            <div className="col-12">
                                <Facets
                                    {...this.props}
                                />
                            </div>
                        </div>
                        
                        <div className="row">
                            <Button
                             onClick={() => onShowMobileFacetsChange(false)}
                               className="see-results-button"
                               block
                                >
                                {translateResourceString('/Search/SeeResults')}
                            </Button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

MobileFacets.propType = {
    ...AttributesParamShape
};

export default MobileFacets;